<div class="container-fluid router-outlet">
  <div class="main-wrapper">
        <ng-content></ng-content>
  </div>
</div>